import { OpenAPIExample } from '../OpenAPIExample';
import { generateSchemaExample } from '../generateSchemaExample';
import { tString } from '../translate';
import { checkIsReference } from '../utils';
/**
 * Generate an example from a reference object.
 */
export function getExampleFromReference(ref, context) {
    return {
        summary: tString(context.translation, 'unresolved_reference'),
        value: { $ref: ref.$ref },
    };
}
/**
 * Get examples from a media type object.
 */
export function getExamplesFromMediaTypeObject(args) {
    var _a;
    var _b, _c;
    var mediaTypeObject = args.mediaTypeObject, mediaType = args.mediaType, context = args.context;
    if (mediaTypeObject.examples) {
        return Object.entries(mediaTypeObject.examples).map(function (_a) {
            var key = _a[0], example = _a[1];
            return {
                key: key,
                example: checkIsReference(example)
                    ? getExampleFromReference(example, context)
                    : example,
            };
        });
    }
    if (mediaTypeObject.example) {
        return [{ key: 'default', example: { value: mediaTypeObject.example } }];
    }
    if (mediaTypeObject.schema) {
        if (mediaType === 'application/xml') {
            // @TODO normally we should use the name of the schema but we don't have it
            // fix it when we got the reference name
            var root = (_c = (_b = mediaTypeObject.schema.xml) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : 'object';
            return [
                {
                    key: 'default',
                    example: {
                        value: (_a = {},
                            _a[root] = generateSchemaExample(mediaTypeObject.schema, {
                                xml: mediaType === 'application/xml',
                                mode: 'read',
                            }),
                            _a),
                    },
                },
            ];
        }
        return [
            {
                key: 'default',
                example: {
                    value: generateSchemaExample(mediaTypeObject.schema, {
                        mode: 'read',
                    }),
                },
            },
        ];
    }
    return [];
}
/**
 * Get example from a schema object.
 */
export function getExampleFromSchema(args) {
    var schema = args.schema;
    if (schema.example) {
        return { value: schema.example };
    }
    return { value: generateSchemaExample(schema, { mode: 'read' }) };
}
/**
 * Get the examples from a media type object.
 */
export function getExamples(props) {
    var mediaTypeObject = props.mediaTypeObject, mediaType = props.mediaType, context = props.context;
    var examples = getExamplesFromMediaTypeObject({ mediaTypeObject: mediaTypeObject, mediaType: mediaType, context: context });
    var syntax = getSyntaxFromMediaType(mediaType);
    return examples.map(function (example) {
        return {
            key: example.key,
            label: example.example.summary || example.key,
            body: (<OpenAPIExample example={example.example} context={props.context} syntax={syntax}/>),
        };
    });
}
/**
 * Get the syntax from a media type.
 */
function getSyntaxFromMediaType(mediaType) {
    if (mediaType.includes('json')) {
        return 'json';
    }
    if (mediaType === 'application/xml') {
        return 'xml';
    }
    return 'text';
}
